export default __webpack_public_path__ + "static/media/discord.eb53f39e.png";